import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {FieldNameTranslationIds} from "../utils/fieldNameTranslationIds";

JournalField.propTypes = {
    action: PropTypes.string,
    field: PropTypes.string,
    hasOldValue: PropTypes.bool,
    hasNewValue: PropTypes.bool
};

function JournalField({action = 'update', field, hasOldValue = false, hasNewValue = false}) {
    if (!field) {
        return null;
    }

    if (hasOldValue === false && hasNewValue === false) {
        return null
    }

    const fieldNameTranslationId = FieldNameTranslationIds[field];
    const fieldLabel = fieldNameTranslationId ? <FormattedMessage id={fieldNameTranslationId} /> : field;

    if (hasOldValue === true && hasNewValue === false) {
        return <div><FormattedMessage id='product.show.modificationLog.field.removed' values={{field: fieldLabel}} /></div>
    }

    if (hasOldValue === false && hasNewValue === true) {
        return <div><FormattedMessage id='product.show.modificationLog.field.generated' values={{field: fieldLabel}} /></div>
    }

    if (hasOldValue && hasNewValue) {
        const isLockAction = action ==='lock' || action === 'unlock';

        return <div>{isLockAction && 'Lock'} <FormattedMessage id='product.show.modificationLog.field.changed' values={{field: fieldLabel}} /></div>
    }

    return fieldLabel;
}

export default JournalField;
